define(function (require) {
    "use strict";

    // todo - implement webpack-error-handler?
    var windowErrorHandler = require("windowErrorHandler");

    // Set custom error handling for window errors which are not caught by the modules
    // Override previous handler.
    window.onerror = windowErrorHandler;
    
    // Set custom error handling for window promise rejections to invoke the onerror handler
    // Override previous handler.
    window.onunhandledrejection = function(error) {
        var reason = error && error.reason || error;
        var promise = error && error.promise;
        window.onerror(reason.message, "", "", "", reason);
    };
});
